import { render, staticRenderFns } from "./Unauthenticated.vue?vue&type=template&id=06854221"
import script from "./Unauthenticated.vue?vue&type=script&lang=js"
export * from "./Unauthenticated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports